"use client";

import { scopeToInstanceBasePath } from "@/lib/named-org";
import NextLink from "next/link";
import { usePathname } from "next/navigation";
import { forwardRef, type ComponentPropsWithoutRef } from "react";

type DashboardLinkProps = ComponentPropsWithoutRef<typeof NextLink> & {
  /** Instance the link targets; defaults to the one the current URL addresses. */
  instanceSlug?: string | null;
};

/**
 * `next/link` whose root-relative hrefs stay on the enterprise instance the
 * current URL addresses: on `/enterprise/ghe/acme/runs`, `href="/acme/home"`
 * renders `/enterprise/ghe/acme/home`. Hrefs are written for github.com.
 */
const DashboardLink = forwardRef<HTMLAnchorElement, DashboardLinkProps>(
  function DashboardLink({ href, instanceSlug, ...props }, ref) {
    const pathname = usePathname() ?? "";
    const basePathname =
      instanceSlug === undefined
        ? pathname
        : instanceSlug
        ? `/enterprise/${encodeURIComponent(instanceSlug)}`
        : "/";
    return (
      <NextLink
        ref={ref}
        href={scopeToInstanceBasePath(href, basePathname)}
        {...props}
      />
    );
  },
);

export default DashboardLink;
